import axios from "@helpers/axios/public.axios";
import { AUTH, USER } from "../../constants";
import { getWallets, updateWalletEvent } from "@actions/wallet/changeWallet";

export const registrationVerify =
  ({ hash }) =>
  async (dispatch) => {
    try {
      const response = await axios.post("/users/verify", {
        hash,
      });

      const { user, token } = response.data.data;

      console.log(response, hash);

      dispatch({
        type: AUTH.AUTH_RESPONSE,
        payload: {
          user,
          token,
          isDemoUser: false,
        },
      });
      // dispatch({ type: AUTH.AUTH_IS_AUTH, payload: false });

      dispatch({ type: USER.USER_RESPONSE, payload: { user } });

      await dispatch(getWallets());
      dispatch(updateWalletEvent());

      return {
        user,
        token,
      };
    } catch (e) {
      dispatch({ type: AUTH.AUTH_ERROR, payload: e.response.data.message });
      throw e;
    }
  };
